const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMobileBottomCurve(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 219.93,
    height: 154.79,
    viewBox: "0 0 219.93 154.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3029",
    d: "M1155 193v154.79A372.951 372.951 0 0 1 1374.93 193z",
    style: {
      fill: "#169134"
    },
    transform: "translate(-1155 -193)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3030",
    d: "M1155 193v57.319c1.256-1.134 2.51-2.272 3.779-3.391 2.487-2.19 5.007-4.34 7.523-6.494 1.631-1.392 3.243-2.8 4.886-4.181 2.7-2.268 5.442-4.49 8.176-6.714 1.5-1.215 2.976-2.454 4.485-3.661a686.68 686.68 0 0 1 9.733-7.6c1.052-.812 2.091-1.651 3.153-2.452q6.539-4.986 13.2-9.809c.428-.31.87-.611 1.3-.918q5.982-4.32 12.055-8.5c1.455-1 2.935-1.968 4.4-2.962l.941-.635z",
    style: {
      fill: "#45a82c"
    },
    transform: "translate(-1155 -193)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileBottomCurve);
export default __webpack_public_path__ + "static/media/mobile-bottom-curve.0473e94340fe59153df098e829d71707.svg";
export { ForwardRef as ReactComponent };